<template>
  <v-dialog
    v-if="role('admin', 'safetyRepresentative')"
    v-model="show"
    persistent
    @keydown.esc="hide"
    width="500"
  >
    <v-card>
      <v-card-title>
        {{ dialogTitle }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-textarea
            v-for="(locale, i) in locales"
            rows="1"
            auto-grow
            :key="i"
            v-model="translationInternal[locale.value]"
            :label="locale.value.toUpperCase()"
            hide-details="auto"
            :rules="[rules.exists]"
          />
        </v-form>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey" text @click="hide">{{ $t("dialog.cancel") }}</v-btn>

        <v-btn color="primary" text @click="add" :loading="loading">{{
          id ? $t("dialog.change") : $t("dialog.add")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    translation: {
      type: Array,
      required: true,
      default: [],
    },
    id: {
      type: [Number, String],
    },
    dialogTitle: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      translationInternal: {},
      rules: this.defaultRules(),
    };
  },
  mounted() {
    this.deactiveRules();
    this.toLocal(this.translation);
  },
  watch: {
    translation(newVal) {
      this.toLocal(newVal);
    },
  },
  computed: {
    ...mapGetters(["role", "locales"]),
  },
  methods: {
    toLocal(locales) {
      if (!locales || !Array.isArray(locales)) {
        return;
      }

      for (const locale of locales) {
        if (locale.text) {
          this.translationInternal[locale.language] = locale.text;
        }
      }
    },
    hide() {
      this.deactiveRules();
      this.$refs.form.resetValidation();
      this.translationInternal = {};
      this.$emit("hide");
    },
    add() {
      this.activateRules();
      if (!this.hasAtleastOneLocale()) {
        this.$store.commit("push_global_message", {
          color: "error",
          text: this.$i18n.t("validation.atleastOne"),
        });
        return;
      }
      this.$nextTick(() => {
        if (!this.$refs.form.validate()) {
          return;
        }
        const translations = Object.entries(this.translationInternal)
          .filter(([, text]) => text && text.trim() !== "")
          .map(([language, text]) => ({
            language,
            text: text.trim(),
          }));
        this.$emit("add", translations);
        this.$emit("hide");
      });
    },
    hasAtleastOneLocale() {
      return Object.values(this.translationInternal).some((value) => value);
    },
    deactiveRules() {
      this.rules = this.defaultRules();
    },
    activateRules() {
      this.rules = {
        exists: () => true,
      };
    },
    defaultRules() {
      return {
        exists: () => true,
      };
    },
  },
};
</script>
